// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__21JAY","tabsBox":"styles_tabsBox__5H2jT","createButton":"styles_createButton__2Xero"};